import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAdminAuth } from "../context/AdminAuthContext";

const AdminGate = () => {
  const { user, role, loading } = useAdminAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="page">
        <div className="card loading-card">
          <div className="loading-title">Loading admin console...</div>
          <div className="loading-subtitle">Syncing access and permissions.</div>
          <div className="loading-bar" />
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (!role) {
    return <Navigate to="/access-denied" replace />;
  }

  return <Outlet />;
};

export default AdminGate;
